const s = window.VITE_PUBLIC_URL ? window.VITE_PUBLIC_URL : "/", t = {
  ALARM_CLOCK_ORANGE: `${s}static/alarm-clock-orange.31fb90d9.svg`,
  ALARM_CLOCK_PURPLE: `${s}static/alarm-clock-purple.06d4911c.svg`,
  ALIEN_1: `${s}static/alien-1.fc7ba696.svg`,
  ALIEN_2: `${s}static/alien-2.15fdda07.svg`,
  ALIEN_3: `${s}static/alien-3.2664a37f.svg`,
  ALIEN_4: `${s}static/alien-4.06ac66da.svg`,
  BLUE_CLIP: `${s}static/blue-clip.87cc4543.svg`,
  BOOK_GREEN: `${s}static/book-green.20f6eed3.svg`,
  BOOK_OPEN_BLUE: `${s}static/book-open-blue.d4f8d08c.svg`,
  BOOK_ORANGE: `${s}static/book-orange.04bdc75e.svg`,
  BOOK_YELLOW: `${s}static/book-yellow.c210ac06.svg`,
  BULLET_YELLOW: `${s}static/bullet-yellow.2f892d88.svg`,
  CALENDAR_BLUE: `${s}static/calendar-blue.e0d52d09.svg`,
  CALENDAR_GRAY: `${s}static/calendar-gray.1c72682a.svg`,
  CALENDAR_GREEN: `${s}static/calendar-green.a2b6a393.svg`,
  CALENDAR_WITH_TICK: `${s}static/calendar-with-tick.94b19c03.svg`,
  CAUTION: `${s}static/caution.5766a967.svg`,
  CHAT_MESSAGES: `${s}static/chat-messages.519aac21.svg`,
  CIRCLE_CUEMATH_LOGO: `${s}static/circle-cuemath-logo.8bcb1ad4.svg`,
  CIRCLE_OUTERCIRCLE_BG: `${s}static/circle-outercircle-bg.65f21460.svg`,
  CLOCK_ORANGE: `${s}static/clock-orange.c144059b.svg`,
  CROSSHAIR_CIRCLE: `${s}static/crosshair-circle.522a26ea.svg`,
  CROWN: `${s}static/crown.c18fa217.svg`,
  CROWN_OVERLAY: `${s}static/crown-overlay.11fb073c.svg`,
  CUECOIN_GOLD: `${s}static/cuecoin-gold.bcb8085e.svg`,
  DESKTOP_WITH_PURPLE_FILL: `${s}static/desktop-with-purple-fill.dfec66cc.svg`,
  DUMMY_PROFILE_1: `${s}static/dummy-profile-1.e1728aed.svg`,
  DUMMY_PROFILE_2: `${s}static/dummy-profile-2.8c799436.svg`,
  DUMMY_PROFILE_3: `${s}static/dummy-profile-3.92417288.svg`,
  DUMMY_PROFILE_4: `${s}static/dummy-profile-4.92ee033d.svg`,
  DUMMY_PROFILE_5: `${s}static/dummy-profile-5.6645518c.svg`,
  DUMMY_PROFILE_6: `${s}static/dummy-profile-6.48b693cd.svg`,
  EARTH_GREEN: `${s}static/earth-green.e1329b7a.svg`,
  ENRICHMENT: `${s}static/enrichment.269e461e.svg`,
  GLOBE_WITH_BLUE_FILL: `${s}static/globe-with-blue-fill.beae6ca4.svg`,
  GRADE_GRID_BACKGROUND: `${s}static/grade-grid-background.b17b4ccb.svg`,
  GRADUATE_HAT: `${s}static/graduate-hat.4b49eb44.svg`,
  GRADUATE_ICON_PINK: `${s}static/graduate-icon-pink.01fbfb1b.svg`,
  GRADUATE_PINK_FILLED_BG: `${s}static/graduate-pink-filled-bg.c91e9c53.svg`,
  GREEN_BALLOON: `${s}static/green-balloon.67ac8587.svg`,
  GREEN_FACE: `${s}static/green-face.1b4dd82f.svg`,
  LEARNED_SHIELD_GRAY: `${s}static/learned-shield-gray.1495b0d5.svg`,
  LEARNED_SHIELD_GREEN: `${s}static/learned-shield-green.7c26b423.svg`,
  LEARNT: `${s}static/learnt.870c5e38.svg`,
  LEARNT_GREEN: `${s}static/learnt-green.dbbb6d74.svg`,
  LIKE: `${s}static/like.cb492460.svg`,
  LIVE_SESSION: `${s}static/live-session.a0d25c78.svg`,
  LOADER: `${s}static/loader.52f8c35c.svg`,
  LOADER_1: `${s}static/loader-1.6524355e.svg`,
  LOCKED: `${s}static/locked.0c3b7577.svg`,
  MASTERED_BADGE: `${s}static/mastered-badge.81f156fb.svg`,
  MASTERED_SHIELD_GRAY: `${s}static/mastered-shield-gray.a58cbe19.svg`,
  MASTERED_SHIELD_GREEN: `${s}static/mastered-shield-green.070fa4eb.svg`,
  MILESTONE_INTRO_1: `${s}static/milestone-intro-1.281a354c.svg`,
  MILESTONE_INTRO_2: `${s}static/milestone-intro-2.19faee69.svg`,
  MILESTONE_INTRO_3: `${s}static/milestone-intro-3.6f6055d6.svg`,
  MISTAKE: `${s}static/mistake.476d1aa7.svg`,
  NUMBER_1_ORANGE: `${s}static/number-1-orange.cbf526ed.svg`,
  NUMBER_2_ORANGE: `${s}static/number-2-orange.6f29eb72.svg`,
  NUMBER_3_ORANGE: `${s}static/number-3-orange.58baf717.svg`,
  NUMBER_4_ORANGE: `${s}static/number-4-orange.5ed1ec5e.svg`,
  ONE_STAR_FILLED: `${s}static/one-star-filled.bf855dff.svg`,
  ORANGE_FACE: `${s}static/orange-face.f2c1580a.svg`,
  PEOPLE_WITH_ORANGE_FILL: `${s}static/people-with-orange-fill.3835b8f1.svg`,
  PERSONALIZATION: `${s}static/personalization.e4b45469.svg`,
  PINK_FOOTBALL_ICON: `${s}static/pink-football-icon.612ec749.svg`,
  PLAY: `${s}static/play.68d16dec.svg`,
  PLAY_ICON: `${s}static/play-icon.13baaa7d.svg`,
  POINTS_SUM: `${s}static/points-sum.360e63de.svg`,
  PRACTICED_SHIELD_GREEN: `${s}static/practiced-shield-green.90278855.svg`,
  PRACTICED_SHIELD_GREY: `${s}static/practiced-shield-grey.16cf4fe0.svg`,
  PROFICIENT_BADGE: `${s}static/proficient-badge.1a6dbb72.svg`,
  PROFILE_BOARD: `${s}static/profile-board.4f4a17e6.svg`,
  PUZZLE_STUDENT: `${s}static/puzzle-student.de530364.svg`,
  PROGRESS_STEPS: `${s}static/progress-steps.93f9bfa4.svg`,
  REFUND_POLICY: `${s}static/refund-policy.912dbb4c.svg`,
  ROCKET_BROKEN: `${s}static/rocket-broken.1f86fa43.svg`,
  ROCKET_YELLOW: `${s}static/rocket-yellow.62d27e15.svg`,
  SCHOOL_SUCCESS: `${s}static/school-success.03dcca17.svg`,
  SCORE: `${s}static/score.41971107.svg`,
  SESSION_GOAL: `${s}static/session-goal.a59009b8.svg`,
  SESSION_LEARNING: `${s}static/session-learning.2c8ac650.svg`,
  SESSION_STEP: `${s}static/session-step.b6c81efe.svg`,
  SMILEY: `${s}static/smiley.49bb7d7c.svg`,
  STAR_ORANGE: `${s}static/star-orange.a91a341f.svg`,
  STAR_ORANGE_FILLED: `${s}static/star-orange-filled.a7ff9c8f.svg`,
  STAR_WITH_GREEN_FILL: `${s}static/star-with-green-fill.86877d41.svg`,
  STREAK_GREEN: `${s}static/streak-green.b59bf4dd.svg`,
  STREAK_WHITE: `${s}static/streak-white.2cbdc9b8.svg`,
  TEST_PREP: `${s}static/test-prep.64e4a2c9.svg`,
  THREE_STARS_FILLED: `${s}static/three-stars-filled.09cebaeb.svg`,
  TICK_GREEN: `${s}static/tick-green.a1654049.svg`,
  TROPHY_BLUE: `${s}static/trophy-blue.e684ba4c.svg`,
  TROPHY_BLUE_FILLED: `${s}static/trophy-blue-filled.7e2b40ab.svg`,
  TROPHY_CIRCLE: `${s}static/trophy-circle.b7b23e36.svg`,
  TROPHY_GREEN: `${s}static/trophy-green.6c0741c8.svg`,
  TWO_STARS_FILLED: `${s}static/two-stars-filled.1e39b20e.svg`,
  UP_ARROW: `${s}static/up-arrow.a6946bd3.svg`,
  USER_CROWN_GRID_BACKGROUND: `${s}static/user-crown-grid-background.c2875a73.svg`,
  USER_DOWN: `${s}static/user-down.a06f2f94.svg`,
  USER_PIN: `${s}static/user-pin.5f334465.svg`,
  USER_PROFILE_BACKGROUND: `${s}static/user-profile-background.199977a9.svg`,
  USER_UP: `${s}static/user-up.2aecbbae.svg`,
  YELLOW_FACE: `${s}static/yellow-face.fd4f5372.svg`
};
export {
  t as ILLUSTRATIONS
};
//# sourceMappingURL=illustrations.js.map
